import { Component, OnInit } from '@angular/core';
import { AdsCampaign } from 'src/app/classes/ads-campaign';
import AdsPlacementStatuses from 'src/app/constants/ads-placement-statuses';
import { AdsPlacementService } from 'src/app/classes/ads-placement.service';
import { AdsPlacement } from 'src/app/classes/ads-placement';

@Component({
  selector: 'app-recent',
  templateUrl: './recent.component.html',
  styleUrls: ['./recent.component.css']
})
export class RecentComponent implements OnInit {

  adsPlacements: AdsPlacement[] = [];

  adsPlacementStatuses = AdsPlacementStatuses;

  constructor(
    private adsPlacementService: AdsPlacementService
  ) { }

  ngOnInit(): void {
    this.adsPlacementService.recent().subscribe(adsPlacements => {
      this.adsPlacements = adsPlacements;
    });
  }

  delete(id: number) {
    if(confirm($localize`Are you sure?`)) {
      this.adsPlacementService.delete(id).subscribe(() => {
        this.adsPlacementService.recent().subscribe(adsPlacements => {
          this.adsPlacements = adsPlacements;
        });
      });
    }
  }
}
